<template>
    <div class="chat-separator w-100">
        <a-divider class="_divider">{{ time() }}</a-divider>
        <span class="desc">{{ $t("message.newConversationStarted") }}</span>
    </div>
</template>
<script>
import moment from "moment";
import { log2 } from "../../../utils/log2";

const log = log2("ChatSeparatorMessage");
export default {
    name: "ChatSeparatorMessage",
    props: {
        createdDate: {
            type: String,
            required: true,
        },
    },
    methods: {
        time() {
            const isToday = moment().isSame(moment(this.createdDate), "day");
            if (isToday) {
                return moment(this.createdDate).calendar();
            } else {
                return moment(this.createdDate).format("LL");
            }
        },
    },
    mounted() {},
};
</script>
<style lang="scss">
.chat-separator {
    .desc {
        width: 100%;
        display: flex;
        justify-content: center;
        color: #8a8a8a;
        font-size: 12px;
    }

    .ant-divider-horizontal.ant-divider-with-text-center {
        margin: 3px 0px;
    }
}

._divider.ant-divider {
    span.ant-divider-inner-text {
        font-size: 12px !important;
        color: #8a8a8a !important;
    }
}
</style>
